import { render, staticRenderFns } from "./DataUser.vue?vue&type=template&id=6e7136da&scoped=true&"
import script from "./DataUser.vue?vue&type=script&lang=js&"
export * from "./DataUser.vue?vue&type=script&lang=js&"
import style0 from "./DataUser.vue?vue&type=style&index=0&id=6e7136da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7136da",
  null
  
)

export default component.exports